<template>
<div>
    <div v-if="label != null">{{ label }}</div>
    <v-card-text v-if="text != null">{{ text }}</v-card-text>
    <v-card class="ma-2 elevation-5">
        <VueSignaturePad @click.native="save" id="signature" width="100%" :height="(length != null ? length : '200') + 'px'" ref="signaturePad" :options="{}" />
        <v-divider />
        <v-card-actions>
            <v-layout>
                <v-btn icon @click="clear" color="error">
                    <v-icon>mdi-eraser</v-icon>
                </v-btn>
                <v-spacer />
                <v-btn icon @click="undo" color="primary">
                    <v-icon>mdi-undo</v-icon>
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</div>
</template>

<script>
export default {
    name: 'draw-content',
    props: ['value', 'length', 'label', 'text'],
    data() {
        return {

        }

    },
    watch: {

    },
    methods: {
        ready() {
            this.$refs.signaturePad.resizeCanvas()
        },
        clear() {
            this.$refs.signaturePad.clearSignature()
        },
        undo() {
            this.$refs.signaturePad.undoSignature();
        },
        save() {

            this.$refs.signaturePad.resizeCanvas()
            const {
                isEmpty,
                data
            } = this.$refs.signaturePad.saveSignature();
            if (isEmpty) return;

            let base64Raw = data.replace('data:image/png;base64,', '');
            this.$emit('input', base64Raw);

        },
    },

    mounted() {
        this.$nextTick(this.ready)
    }
}
</script>
